import { createAPI } from '@/utils/modal'
import UserAgentModal from '../components/UserAgentModal'
import { agentLoginSubAccount, AgentLoginParams } from '@/modules/admin/help'
import { getUserList } from './getUserList'

/** 打开代理登录子账号选择器 */
export async function openAgentLoginSubAccountSelector(params: AgentLoginParams) {
    const { redirect, coId, onSuccess } = params
    const options = await getUserList(coId)
    if (options?.length > 0) {
        const { destroy } = createAPI(UserAgentModal, {
            coId,
            options,
            onOk: async ({ userData }: any) => {
                await agentLoginSubAccount({
                    userData: {
                        ...userData,
                        coId
                    },
                    redirect,
                    onSuccess
                })
                destroy()
            }
        })
    }
}
